import type { Components } from '@mui/material/styles';

export default function MuiSpeedDial(): Components['MuiSpeedDial'] {
  return {};
}
